import { Box } from '@chakra-ui/react';
import Layout from 'components/common/Layout';
import { Link, Text } from 'components/UI';
import AppRoutes from 'constants/routes';

const PageNotFound = () => (
  <Layout>
    <Box w="full" textAlign="center" py={14}>
      <Text mb={6}>Sorry, we couldn&apos;t find what you were looking for.</Text>
      <Link variant="button" py={2.5} to={AppRoutes.Landing}>
        GO HOME
      </Link>
    </Box>
  </Layout>
);

export default PageNotFound;
